var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad-emoji",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_584",
    "data-name": "Ellipse 584",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#d1d1cf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M21.329,11.329A10,10,0,0,1,3.545,17.608,10,10,0,0,0,17.608,3.545,9.989,9.989,0,0,1,21.329,11.329Z",
    transform: "translate(-1.329 -1.329)",
    fill: "#d1d1cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10516",
    "data-name": "Path 10516",
    d: "M22.96,11.8c.279,1.968-.767,3.738-2.336,3.961s-3.068-1.186-3.347-3.154.766-3.744,2.336-3.968S22.68,9.829,22.96,11.8Z",
    transform: "translate(-6.462 -3.23)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10517",
    "data-name": "Path 10517",
    d: "M22.278,15.317a1.406,1.406,0,1,1-1.4-1.406A1.4,1.4,0,0,1,22.278,15.317Z",
    transform: "translate(-7.3 -5.217)",
    fill: "#3e4347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10518",
    "data-name": "Path 10518",
    d: "M22.6,15.444c-.106.106-.319.069-.475-.087s-.2-.375-.094-.481.313-.069.475.088S22.706,15.337,22.6,15.444Z",
    transform: "translate(-8.24 -5.555)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10519",
    "data-name": "Path 10519",
    d: "M19.08,6.94s1.051,1.511,4.608,1.078C23.688,8.018,18.637,10.3,19.08,6.94Z",
    transform: "translate(-7.145 -2.602)",
    fill: "#3e4347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10520",
    "data-name": "Path 10520",
    d: "M5.576,11.8c-.279,1.968.767,3.738,2.336,3.961S10.98,14.571,11.26,12.6s-.766-3.744-2.336-3.968S5.855,9.829,5.576,11.8Z",
    transform: "translate(-2.074 -3.23)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M10.847,15.317a1.406,1.406,0,1,1-1.4-1.406A1.4,1.4,0,0,1,10.847,15.317Z",
    transform: "translate(-3.013 -5.217)",
    fill: "#3e4347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M11.168,15.444c-.106.106-.319.069-.475-.087s-.2-.375-.094-.481.313-.069.475.088S11.274,15.337,11.168,15.444Z",
    transform: "translate(-3.953 -5.555)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10523",
    "data-name": "Path 10523",
    d: "M9.349,5.111s-.376,1.8-3.819,2.8C5.531,7.906,11.072,8.029,9.349,5.111Zm5.912,11.756a.678.678,0,0,1-.681.675H9.568a.678.678,0,1,1,0-1.356H14.58A.683.683,0,0,1,15.261,16.867Z",
    transform: "translate(-2.074 -1.917)",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageGray);
export default __webpack_public_path__ + "static/media/average_gray.d7ec46a291b53f33967737fa5a7bf119.svg";
export { ForwardRef as ReactComponent };